import { render } from "./task-list-icon.svg?vue&type=template&id=3b082419"
import script from "./task-list-icon.svg?vue&type=script&lang=js"
export * from "./task-list-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4146/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__